import React, { ComponentPropsWithRef } from 'react'
// import Cover from '../assets/f__valuefit.webp'
import { useCommonCtx } from '../context/useCommonCtx'
import { MTypo } from '../components/MTypo/MTypo'
import type { TypographyVariant } from '../types/mui'
import { ALL_LANGUAGES_TYPE } from '../i18n/constants'
import { isMobilePortrait } from '../utils/index'
import { defaultParamsFitme } from '../parameters/defaultParamsFitme'
import { ALL_LANGUAGES, DEFAULT_LOCAL } from '../i18n/constants'
import { getBrandTextByLang } from '../i18n/useTranslation'
import { useTheme } from '@mui/material'

interface Props extends ComponentPropsWithRef<'div'> {
    titleV: TypographyVariant
    bodyV: TypographyVariant
}
/**
 * "Branding screen"
 * Screen 6, redondant with screen 2 'Tell us'
 * Shoud come before screen 5
 * "Branding2 screen, optionnal as branding1 exists before signup"
 * @param p
 * @returns
 */
export const Branding = (p: Props) => {
    const { className, titleV, bodyV, ...rest } = p
    const commons = useCommonCtx()
    const muiTheme = useTheme()
    const {
        state: { params },
    } = commons
    const { brandParams } = params
    const langIndex = params.assessmentParams['langIndex']
    const ln = ALL_LANGUAGES[langIndex] as ALL_LANGUAGES_TYPE
    const text1 =
        getBrandTextByLang(brandParams['brandText1'], ln) ??
        defaultParamsFitme.brandParams.brandText1[DEFAULT_LOCAL]
    const text2 =
        getBrandTextByLang(brandParams['brandText2'], ln) ??
        defaultParamsFitme.brandParams.brandText2[DEFAULT_LOCAL]
    const brandImgSrc = isMobilePortrait()
        ? brandParams['brandImageUrlMobile']
        : brandParams['brandImageUrl']

    return (
        <div
            className="flex flex-1 flex-col justify-around items-center"
            style={{ backgroundColor: muiTheme.palette.background.default }}
        >
            <MTypo variant={titleV} className="text-center">
                {text1}
            </MTypo>
            <div className={'border-0 border-black border-solid p-2 mt-4 mb-6'}>
                {/* <img className={`w-full pointer-events-none`} src={Cover} /> */}
                <img
                    className={`w-full pointer-events-none`}
                    src={brandImgSrc}
                />
            </div>
            <MTypo
                variant={bodyV}
                outerClassName="p-4"
                textClassName="text-center italic"
            >
                {text2}
            </MTypo>
        </div>
    )
}
